(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["witchmark-cta-bar"] && !Shopify.designMode) return;
  try {
    /* Shared gift-switch sync. Queries globally (not scoped) so it picks
     up switches in witchmark-payment-cta AND witchmark-sticky-footer
     (both ship this same IIFE). Per-switch idempotent marker prevents
     double-handlers if both blocks' JS runs on the same page. */
  (function () {
    const switches = Array.from(document.querySelectorAll('.js-wm-gift-switch:not([data-wm-gift-init])'));
    if (!switches.length) return;
    switches.forEach(sw => sw.setAttribute('data-wm-gift-init', 'true'));

    function setGiftMode(isGift) {
      document.querySelectorAll('.js-wm-gift-switch').forEach(sw => {
        if (sw.checked !== isGift) sw.checked = isGift;
      });
      document.querySelectorAll('.wm-payment-cta__form input[name="id"]').forEach(input => {
        const giftId = input.dataset.gift;
        const payId = input.dataset.pay;
        if (!payId) return;
        input.value = isGift && giftId ? giftId : payId;
      });
    }

    switches.forEach(sw => {
      sw.addEventListener('change', () => setGiftMode(sw.checked));
    });

    // Sync on load in case bfcache restored a checked state
    if (switches[0].checked) setGiftMode(true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-cta-panel"] && !Shopify.designMode) return;
  try {
    /* Duplicated from witchmark-payment-cta so this block's gift toggle
     works even if used without the mid-page CTA on a page. Per-switch
     idempotent marker prevents double-handlers when both blocks are
     present. */
  (function () {
    const switches = Array.from(document.querySelectorAll('.js-wm-gift-switch:not([data-wm-gift-init])'));
    if (!switches.length) return;
    switches.forEach(sw => sw.setAttribute('data-wm-gift-init', 'true'));

    function setGiftMode(isGift) {
      document.querySelectorAll('.js-wm-gift-switch').forEach(sw => {
        if (sw.checked !== isGift) sw.checked = isGift;
      });
      document.querySelectorAll('.wm-payment-cta__form input[name="id"]').forEach(input => {
        const giftId = input.dataset.gift;
        const payId = input.dataset.pay;
        if (!payId) return;
        input.value = isGift && giftId ? giftId : payId;
      });
    }

    switches.forEach(sw => {
      sw.addEventListener('change', () => setGiftMode(sw.checked));
    });

    if (switches[0].checked) setGiftMode(true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-distillery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wm-distillery').forEach(initDistilleryProgress);

  function initDistilleryProgress(section) {
    const gallery = section.querySelector('.wm-distillery__gallery');
    const fill = section.querySelector('.wm-distillery__progress-fill');
    if (!gallery || !fill) return;

    const update = () => {
      const max = gallery.scrollWidth - gallery.clientWidth;
      const pct = max > 0 ? gallery.scrollLeft / max : 0;
      const trackW = fill.parentElement.clientWidth;
      fill.style.width = (trackW * pct) + 'px';
    };

    gallery.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Re-measure when images lazy-load (scrollWidth grows)
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(update);
      ro.observe(gallery);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-enquiry"] && !Shopify.designMode) return;
  try {
    /* The contact form posts as a full page load and returns at the top of the
     page, so the confirmation would be off screen. Bring it into view and move
     focus to it, which also announces it to screen readers. */
  (function () {
    var msg = document.querySelector('[data-wm-enquiry-inline-success]');
    if (!msg) return;
    msg.scrollIntoView({ block: 'center', behavior: 'auto' });
    msg.focus({ preventScroll: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-faqs"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wm-faqs').forEach(initFaqs);

  function initFaqs(section) {
    const closeOthers = section.dataset.closeOthers === 'true';
    const firstOpenMobile = section.dataset.firstOpenMobile === 'true';
    const items = Array.from(section.querySelectorAll('.wm-faq'));
    if (!items.length) return;

    const isMobile = () => window.matchMedia('(max-width: 1023px)').matches;

    function closePanel(btn, panel) {
      if (!panel || panel.hidden) return;
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }
    function openPanel(btn, panel) {
      if (!panel || !panel.hidden) return;
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    const buttons = [];

    items.forEach(item => {
      const btn = item.querySelector('[aria-controls]');
      const panel = btn ? section.querySelector('#' + CSS.escape(btn.getAttribute('aria-controls'))) : null;
      if (!btn || !panel) return;
      buttons.push(btn);

      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;

      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (closeOthers && !isOpen) {
          items.forEach(sib => {
            if (sib === item) return;
            const b = sib.querySelector('[aria-controls]');
            const p = b ? section.querySelector('#' + CSS.escape(b.getAttribute('aria-controls'))) : null;
            if (b && p) closePanel(b, p);
          });
        }
        if (isOpen) closePanel(btn, panel); else openPanel(btn, panel);
      });

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          const idx = buttons.indexOf(btn);
          const next = e.key === 'ArrowDown' ? (idx + 1) % buttons.length : (idx - 1 + buttons.length) % buttons.length;
          buttons[next].focus();
        }
      });
    });

    if (firstOpenMobile && isMobile() && items.length) {
      const b = items[0].querySelector('[aria-controls]');
      const p = b ? section.querySelector('#' + CSS.escape(b.getAttribute('aria-controls'))) : null;
      if (b && p) openPanel(b, p);
    }

    let resizeT;
    window.addEventListener('resize', () => {
      clearTimeout(resizeT);
      resizeT = setTimeout(() => {
        if (!items.length) return;
        const first = items[0];
        const b = first.querySelector('[aria-controls]');
        const p = b ? section.querySelector('#' + CSS.escape(b.getAttribute('aria-controls'))) : null;
        if (!b || !p) return;

        if (isMobile() && firstOpenMobile) {
          const anyOpen = items.some(i => {
            const bb = i.querySelector('[aria-controls]');
            return bb && bb.getAttribute('aria-expanded') === 'true';
          });
          if (!anyOpen) openPanel(b, p);
        } else if (!isMobile()) {
          items.forEach(i => {
            const bb = i.querySelector('[aria-controls]');
            const pp = bb ? section.querySelector('#' + CSS.escape(bb.getAttribute('aria-controls'))) : null;
            if (bb && pp) closePanel(bb, pp);
          });
        }
      }, 120);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-feature-grid"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wm-membership').forEach(initMembershipTabs);

  function initMembershipTabs(section) {
    const tabs = Array.from(section.querySelectorAll('.wm-membership__tab'));
    const cards = Array.from(section.querySelectorAll('.wm-membership__feature'));
    const tablist = section.querySelector('.wm-membership__tabs');
    if (!tabs.length || !cards.length || !tablist) return;

    const mq = window.matchMedia('(max-width: 63.99rem)');

    function setActiveTab(tab) {
      tabs.forEach(t => {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', String(isActive));
        t.tabIndex = isActive ? 0 : -1;
      });
    }

    function filterByColumn(col) {
      if (mq.matches) {
        cards.forEach(card => {
          const matches = card.dataset.col === String(col);
          card.classList.toggle('is-hidden', !matches);
          card.toggleAttribute('hidden', !matches);
        });
      } else {
        cards.forEach(card => {
          card.classList.remove('is-hidden');
          card.removeAttribute('hidden');
        });
      }
    }

    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        setActiveTab(btn);
        filterByColumn(btn.dataset.col);
      });
    });

    tablist.addEventListener('keydown', (e) => {
      const idx = tabs.findIndex(t => t.classList.contains('is-active'));
      let next = idx;
      if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      else return;
      e.preventDefault();
      tabs[next].click();
      tabs[next].focus();
    });

    const handleBreakpointChange = () => {
      if (mq.matches) {
        const active = section.querySelector('.wm-membership__tab.is-active') || tabs[0];
        setActiveTab(active);
        filterByColumn(active.dataset.col);
      } else {
        filterByColumn(null);
      }
    };

    if (mq.addEventListener) mq.addEventListener('change', handleBreakpointChange);
    else mq.addListener(handleBreakpointChange);

    const initial = section.querySelector('.wm-membership__tab.is-active') || tabs[0];
    setActiveTab(initial);
    filterByColumn(initial.dataset.col);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-gallery-copy"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wm-distillery').forEach(initDistilleryProgress);

  function initDistilleryProgress(section) {
    const gallery = section.querySelector('.wm-distillery__gallery');
    const fill = section.querySelector('.wm-distillery__progress-fill');
    if (!gallery || !fill) return;

    const update = () => {
      const max = gallery.scrollWidth - gallery.clientWidth;
      const pct = max > 0 ? gallery.scrollLeft / max : 0;
      const trackW = fill.parentElement.clientWidth;
      fill.style.width = (trackW * pct) + 'px';
    };

    gallery.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();

    // Re-measure when images lazy-load (scrollWidth grows)
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(update);
      ro.observe(gallery);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-hero"] && !Shopify.designMode) return;
  try {
    (function () {
    const HEADER_SELECTOR = '.site-header';
    let ro = null;

    function updateHeaderHeight() {
      const header = document.querySelector(HEADER_SELECTOR);
      if (!header) return;
      document.documentElement.style.setProperty('--wm-header-height', header.offsetHeight + 'px');
    }

    function observeHeader() {
      const header = document.querySelector(HEADER_SELECTOR);
      if (!header || ro) return;
      if ('ResizeObserver' in window) {
        ro = new ResizeObserver(updateHeaderHeight);
        ro.observe(header);
      }
    }

    function applyHeaderOverlay() {
      const overlayHero = document.querySelector('.wm-hero[data-overlay-header="true"]');
      if (!overlayHero) return;
      const wrapper = document.querySelector('#HeaderWrapper');
      const siteHeader = document.querySelector('#SiteHeader');
      if (wrapper) wrapper.classList.add('header-wrapper--overlay', 'is-light');
      if (siteHeader) siteHeader.setAttribute('data-overlay', 'true');
    }

    updateHeaderHeight();
    observeHeader();
    applyHeaderOverlay();
    window.addEventListener('load', function () {
      updateHeaderHeight();
      observeHeader();
      applyHeaderOverlay();
    });
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
  })();

  /* Hero is above-the-fold — hydrate the YouTube iframe immediately.
     twc.js's video-embed handler relies on IntersectionObserver, which
     browsers throttle when the tab is hidden (e.g. when viewing inside
     Shopify's theme editor iframe, or after switching tabs). The
     callback never fires → iframe never gets created. This block
     creates the iframe directly on DOMContentLoaded. Idempotent with
     twc.js: we set the .is-loaded class so twc.js skips re-hydration. */
  (function () {
    function ytIdFrom(url) {
      try {
        var u = new URL(url);
        if (u.hostname.indexOf('youtu.be') !== -1) return u.pathname.slice(1);
        if (u.pathname.indexOf('/shorts/') === 0) return u.pathname.split('/')[2];
        if (u.searchParams.get('v')) return u.searchParams.get('v');
        if (u.pathname.indexOf('/embed/') === 0) return u.pathname.split('/')[2];
      } catch (e) {}
      return null;
    }

    function isMobile() {
      return window.matchMedia('(max-width: 1023px)').matches;
    }

    function hydrate(el) {
      if (el.classList.contains('is-loaded')) return;
      if (el.querySelector('iframe')) return;
      var srcDesktop = el.getAttribute('data-src-desktop') || '';
      var srcMobile = el.getAttribute('data-src-mobile') || srcDesktop;
      var src = isMobile() ? srcMobile : srcDesktop;
      if (!src) return;

      var id = ytIdFrom(src);
      if (!id) return;
      var mode = (el.getAttribute('data-mode') || 'background').toLowerCase();
      var common = ['playsinline=1', 'modestbranding=1', 'rel=0', 'iv_load_policy=3'];
      if (mode === 'background') {
        common.push('autoplay=1', 'mute=1', 'controls=0', 'fs=0', 'disablekb=1', 'loop=1', 'playlist=' + id);
      } else {
        common.push('controls=1', 'autoplay=0', 'mute=0');
      }
      var fullSrc = 'https://www.youtube.com/embed/' + id + '?' + common.join('&');

      var iframe = document.createElement('iframe');
      iframe.src = fullSrc;
      iframe.title = el.getAttribute('data-title') || 'Hero background video';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.loading = 'eager';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      el.appendChild(iframe);
      el.classList.add('is-loaded');
    }

    function hydrateAll() {
      document.querySelectorAll('.wm-hero__media.video-embed').forEach(hydrate);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrateAll);
    } else {
      hydrateAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-media-with-accordion"] && !Shopify.designMode) return;
  try {
    /* Single-open behaviour for the media-accordion.
     Replaces the twc.js .accordion handler, which only ran on the two
     templates that load twc.js. Uses a data attribute rather than a class
     so twc.js cannot double-wire these even if the markup changes.

     Rules:
       desktop + always-open-desktop : everything open, summary clicks ignored
       desktop otherwise             : single-open when "Close other items" is on
       mobile (<= breakpoint)        : always single-open, first item open

     <details> still expands natively if this script never runs. */
  document.querySelectorAll('[data-wm-media-accordion]').forEach(initMediaAccordion);

  function initMediaAccordion(acc) {
    var bp = parseInt(acc.dataset.breakpoint || '420', 10);
    var mq = window.matchMedia('(max-width:' + bp + 'px)');
    var alwaysOpenDesktop = acc.dataset.alwaysOpenDesktop === 'true';
    var closeOthers = acc.dataset.closeOthers === 'true';
    var items = function () {
      return Array.prototype.slice.call(acc.querySelectorAll('.wm-media-accordion__item'));
    };

    // Guard against the toggle handler reacting to its own closures.
    var settling = false;

    function closeSiblings(open) {
      settling = true;
      items().forEach(function (other) {
        if (other !== open) other.open = false;
      });
      settling = false;
    }

    acc.addEventListener('toggle', function (e) {
      var d = e.target;
      if (settling || !(d instanceof HTMLDetailsElement) || !d.open) return;
      if (!d.classList.contains('wm-media-accordion__item')) return;
      if (!mq.matches && alwaysOpenDesktop) return;
      if (mq.matches || closeOthers) closeSiblings(d);
    }, true);

    // Desktop always-open: swallow the click so the item can't be collapsed.
    acc.addEventListener('click', function (e) {
      if (mq.matches || !alwaysOpenDesktop) return;
      var sum = e.target.closest('.wm-media-accordion__summary');
      if (!sum) return;
      e.preventDefault();
      var d = sum.closest('details');
      if (d && !d.open) d.open = true;
    }, true);

    function applyMode() {
      var list = items();
      if (!list.length) return;
      if (mq.matches) {
        var open = list.filter(function (d) { return d.open; });
        if (open.length > 1) {
          settling = true;
          open.slice(1).forEach(function (d) { d.open = false; });
          settling = false;
        }
        if (!list.some(function (d) { return d.open; })) list[0].open = true;
      } else if (alwaysOpenDesktop) {
        settling = true;
        list.forEach(function (d) { d.open = true; });
        settling = false;
      } else if (closeOthers) {
        var opened = list.filter(function (d) { return d.open; });
        if (opened.length > 1) closeSiblings(opened[0]);
      }
    }

    if (mq.addEventListener) mq.addEventListener('change', applyMode);
    else mq.addListener(applyMode);
    applyMode();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-membership"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.wm-membership').forEach(initMembershipTabs);

  function initMembershipTabs(section) {
    const tabs = Array.from(section.querySelectorAll('.wm-membership__tab'));
    const cards = Array.from(section.querySelectorAll('.wm-membership__feature'));
    const tablist = section.querySelector('.wm-membership__tabs');
    if (!tabs.length || !cards.length || !tablist) return;

    const mq = window.matchMedia('(max-width: 63.99rem)');

    function setActiveTab(tab) {
      tabs.forEach(t => {
        const isActive = t === tab;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', String(isActive));
        t.tabIndex = isActive ? 0 : -1;
      });
    }

    function filterByColumn(col) {
      if (mq.matches) {
        cards.forEach(card => {
          const matches = card.dataset.col === String(col);
          card.classList.toggle('is-hidden', !matches);
          card.toggleAttribute('hidden', !matches);
        });
      } else {
        cards.forEach(card => {
          card.classList.remove('is-hidden');
          card.removeAttribute('hidden');
        });
      }
    }

    tabs.forEach(btn => {
      btn.addEventListener('click', () => {
        setActiveTab(btn);
        filterByColumn(btn.dataset.col);
      });
    });

    tablist.addEventListener('keydown', (e) => {
      const idx = tabs.findIndex(t => t.classList.contains('is-active'));
      let next = idx;
      if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      else return;
      e.preventDefault();
      tabs[next].click();
      tabs[next].focus();
    });

    const handleBreakpointChange = () => {
      if (mq.matches) {
        const active = section.querySelector('.wm-membership__tab.is-active') || tabs[0];
        setActiveTab(active);
        filterByColumn(active.dataset.col);
      } else {
        filterByColumn(null);
      }
    };

    if (mq.addEventListener) mq.addEventListener('change', handleBreakpointChange);
    else mq.addListener(handleBreakpointChange);

    const initial = section.querySelector('.wm-membership__tab.is-active') || tabs[0];
    setActiveTab(initial);
    filterByColumn(initial.dataset.col);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-payment-cta"] && !Shopify.designMode) return;
  try {
    /* Shared gift-switch sync. Queries globally (not scoped) so it picks
     up switches in witchmark-payment-cta AND witchmark-sticky-footer
     (both ship this same IIFE). Per-switch idempotent marker prevents
     double-handlers if both blocks' JS runs on the same page. */
  (function () {
    const switches = Array.from(document.querySelectorAll('.js-wm-gift-switch:not([data-wm-gift-init])'));
    if (!switches.length) return;
    switches.forEach(sw => sw.setAttribute('data-wm-gift-init', 'true'));

    function setGiftMode(isGift) {
      document.querySelectorAll('.js-wm-gift-switch').forEach(sw => {
        if (sw.checked !== isGift) sw.checked = isGift;
      });
      document.querySelectorAll('.wm-payment-cta__form input[name="id"]').forEach(input => {
        const giftId = input.dataset.gift;
        const payId = input.dataset.pay;
        if (!payId) return;
        input.value = isGift && giftId ? giftId : payId;
      });
    }

    switches.forEach(sw => {
      sw.addEventListener('change', () => setGiftMode(sw.checked));
    });

    // Sync on load in case bfcache restored a checked state
    if (switches[0].checked) setGiftMode(true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-rich-text"] && !Shopify.designMode) return;
  try {
    /* Enquiry modal: open/close handlers + auto-open when the form has
     posted_successfully? Same mechanism as witchmark-text-image but
     scoped to this block's .wm-rich-text__enquiry instances. */
  document.querySelectorAll('.wm-rich-text [data-wm-enquiry-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const dlg = document.getElementById(trigger.getAttribute('data-wm-enquiry-open'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  });

  document.querySelectorAll('.wm-rich-text__enquiry').forEach((dlg) => {
    if (typeof dlg.showModal !== 'function') return;

    dlg.querySelectorAll('[data-wm-enquiry-close]').forEach((btn) => {
      btn.addEventListener('click', () => dlg.close());
    });

    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });

    if (dlg.querySelector('[data-wm-enquiry-success]')) {
      dlg.showModal();
    }
  });

  /* Variant picker modal — same open/close shape; form posts the
     selected variant id to /cart/add via the theme's js-ajax-add hook. */
  document.querySelectorAll('.wm-rich-text [data-wm-picker-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const dlg = document.getElementById(trigger.getAttribute('data-wm-picker-open'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  });

  document.querySelectorAll('.wm-rich-text__picker').forEach((dlg) => {
    if (typeof dlg.showModal !== 'function') return;

    dlg.querySelectorAll('[data-wm-picker-close]').forEach((btn) => {
      btn.addEventListener('click', () => dlg.close());
    });

    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });

    /* Close the picker once theme.AjaxProduct fires its bubbling
       'ajaxProduct:added' event on the inner form — same trigger the
       theme uses to open the cart drawer. */
    dlg.addEventListener('ajaxProduct:added', () => dlg.close());
  });

  /* AJAX add-to-cart wiring (identical to witchmark-text-image) —
     opens the cart drawer instead of redirecting to /cart. Flag-guarded
     so it's safe alongside twc.js and the duplicate snippet in
     witchmark-text-image. Retries across three lifecycle events to
     beat the script-order race with theme.js. */
  (function initWmAjaxAdd() {
    function attach() {
      if (typeof theme === 'undefined' || !theme.AjaxProduct) return;
      document.querySelectorAll('form.js-ajax-add').forEach((form) => {
        if (form.dataset.ajaxInit) return;
        new theme.AjaxProduct(form, '.add-to-cart');
        form.dataset.ajaxInit = '1';
      });
    }
    attach();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    }
    window.addEventListener('load', attach);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-sticky-footer"] && !Shopify.designMode) return;
  try {
    /* Duplicated from witchmark-payment-cta so this block's gift toggle
     works even if used without the mid-page CTA on a page. Per-switch
     idempotent marker prevents double-handlers when both blocks are
     present. */
  (function () {
    const switches = Array.from(document.querySelectorAll('.js-wm-gift-switch:not([data-wm-gift-init])'));
    if (!switches.length) return;
    switches.forEach(sw => sw.setAttribute('data-wm-gift-init', 'true'));

    function setGiftMode(isGift) {
      document.querySelectorAll('.js-wm-gift-switch').forEach(sw => {
        if (sw.checked !== isGift) sw.checked = isGift;
      });
      document.querySelectorAll('.wm-payment-cta__form input[name="id"]').forEach(input => {
        const giftId = input.dataset.gift;
        const payId = input.dataset.pay;
        if (!payId) return;
        input.value = isGift && giftId ? giftId : payId;
      });
    }

    switches.forEach(sw => {
      sw.addEventListener('change', () => setGiftMode(sw.checked));
    });

    if (switches[0].checked) setGiftMode(true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-text-image"] && !Shopify.designMode) return;
  try {
    /* Tiny progressive enhancement: any underlined word inside the footer
     text becomes a focusable, ARIA-described tooltip trigger. We accept
     both <u> tags and Shopify's rich-text spans (which use
     style="text-decoration:underline" rather than the <u> element).
     Each matching element is tagged with .wm-intro__footer-trigger so a
     single CSS rule handles styling and :has() visibility, regardless
     of which underline syntax the merchant produced. */
  document.querySelectorAll('.wm-intro__footer-block').forEach((block) => {
    const tooltip = block.querySelector('.wm-intro__tooltip');
    if (!tooltip) return;
    const triggers = block.querySelectorAll(
      '.wm-intro__footer u, .wm-intro__footer span[style*="underline"]'
    );
    triggers.forEach((el) => {
      el.classList.add('wm-intro__footer-trigger');
      /* Clear the inline text-decoration so the dotted-underline style
         from CSS can take precedence (inline beats class otherwise). */
      el.style.textDecoration = '';
      el.tabIndex = 0;
      el.setAttribute('aria-describedby', tooltip.id);
    });
  });

  /* Enquiry modal: open/close handlers + auto-open when Shopify has
     redirected back with form.posted_successfully? (the Liquid renders
     a [data-wm-enquiry-success] marker inside the dialog in that case). */
  document.querySelectorAll('[data-wm-enquiry-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const dlg = document.getElementById(trigger.getAttribute('data-wm-enquiry-open'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  });

  document.querySelectorAll('.wm-intro__enquiry').forEach((dlg) => {
    if (typeof dlg.showModal !== 'function') return;

    dlg.querySelectorAll('[data-wm-enquiry-close]').forEach((btn) => {
      btn.addEventListener('click', () => dlg.close());
    });

    /* Click on the dialog's own backdrop closes — the click target is
       the <dialog> element itself when the user clicks outside the
       inner content. */
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });

    if (dlg.querySelector('[data-wm-enquiry-success]')) {
      dlg.showModal();
    }
  });

  /* Variant picker modal: same open/close shape as the enquiry modal.
     The form inside posts the chosen variant id to /cart/add via the
     theme's existing js-ajax-add handler. */
  document.querySelectorAll('[data-wm-picker-open]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const dlg = document.getElementById(trigger.getAttribute('data-wm-picker-open'));
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  });

  document.querySelectorAll('.wm-intro__picker').forEach((dlg) => {
    if (typeof dlg.showModal !== 'function') return;

    dlg.querySelectorAll('[data-wm-picker-close]').forEach((btn) => {
      btn.addEventListener('click', () => dlg.close());
    });

    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });

    /* theme.AjaxProduct fires 'ajaxProduct:added' on the form (bubbles)
       once /cart/add returns successfully — same event the theme uses
       to open the cart drawer. Close the picker so the drawer doesn't
       sit on top of an open modal. */
    dlg.addEventListener('ajaxProduct:added', () => dlg.close());
  });

  /* AJAX add-to-cart wiring: Motion theme.js loads globally so
     theme.AjaxProduct is available everywhere, but the wiring only
     runs in twc.js (which is only loaded on TWC templates). Lift it
     here so the cart drawer opens on any template carrying our blocks.
     Idempotent via data-ajax-init — safe alongside twc.js.

     Retry across three lifecycle events because the compiled block
     bundle can execute before theme.js finishes defining
     theme.AjaxProduct (script-order race). First call that finds
     theme ready wins; the flag prevents subsequent ones from
     re-initializing the same form. */
  (function initWmAjaxAdd() {
    function attach() {
      if (typeof theme === 'undefined' || !theme.AjaxProduct) return;
      document.querySelectorAll('form.js-ajax-add').forEach((form) => {
        if (form.dataset.ajaxInit) return;
        new theme.AjaxProduct(form, '.add-to-cart');
        form.dataset.ajaxInit = '1';
      });
    }
    attach();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    }
    window.addEventListener('load', attach);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-three-column"] && !Shopify.designMode) return;
  try {
    /* AJAX add-to-cart wiring (mirrors witchmark-text-image and
     witchmark-rich-text). Opens the cart drawer instead of redirecting
     to /cart. Idempotent via data-ajax-init flag, retries across the
     three lifecycle events to beat the script-order race with theme.js. */
  (function initWmAjaxAdd() {
    function attach() {
      if (typeof theme === 'undefined' || !theme.AjaxProduct) return;
      document.querySelectorAll('form.js-ajax-add').forEach((form) => {
        if (form.dataset.ajaxInit) return;
        new theme.AjaxProduct(form, '.add-to-cart');
        form.dataset.ajaxInit = '1';
      });
    }
    attach();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attach);
    }
    window.addEventListener('load', attach);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["witchmark-video-feature"] && !Shopify.designMode) return;
  try {
    /* Lift of the YouTube-iframe hydration handler from twc.js so this
     block works on any template (twc.js only loads on TWC). Idempotent
     with twc.js — both bail when .is-loaded is already set. */
  document.querySelectorAll('.wm-founder__video-embed[data-mode]').forEach(initEmbed);

  function initEmbed(el) {
    if (el.classList.contains('is-loaded')) return;

    const mode = (el.getAttribute('data-mode') || 'player').toLowerCase();
    const title = el.getAttribute('data-title') || 'Video';

    function ytId(url) {
      try {
        const u = new URL(url);
        if (u.hostname.includes('youtu.be')) return u.pathname.slice(1);
        if (u.pathname.startsWith('/shorts/')) return u.pathname.split('/')[2];
        if (u.searchParams.get('v')) return u.searchParams.get('v');
        if (u.pathname.startsWith('/embed/')) return u.pathname.split('/')[2];
      } catch (e) {}
      return null;
    }

    function chooseSrc() {
      const isMobile = window.matchMedia('(max-width: 1023px)').matches;
      const desktop = el.getAttribute('data-src-desktop') || '';
      const mobile = el.getAttribute('data-src-mobile') || desktop;
      return isMobile ? mobile : desktop;
    }

    function hydrate(withAutoplay) {
      if (el.classList.contains('is-loaded')) return;
      const id = ytId(chooseSrc());
      if (!id) return;

      const params = [
        'playsinline=1',
        'modestbranding=1',
        'rel=0',
        'iv_load_policy=3',
        'controls=1',
        'mute=0'
      ];
      if (withAutoplay || mode === 'background') params.push('autoplay=1');
      if (mode === 'background') {
        params.push('controls=0', 'mute=1', 'loop=1', `playlist=${id}`, 'fs=0', 'disablekb=1');
      }

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube.com/embed/${id}?${params.join('&')}`;
      iframe.title = title;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      el.appendChild(iframe);
      el.classList.add('is-loaded');
    }

    /* Click-to-play: explicit user gesture hydrates with autoplay so
       the video starts immediately. Without this the play button is
       cosmetic. */
    const playBtn = el.querySelector('.wm-founder__video-play');
    if (playBtn) {
      playBtn.addEventListener('click', () => hydrate(true));
    }

    /* Lazy-hydrate on intersection so the iframe is already mounted by
       the time the user scrolls to it (matches twc.js behaviour). No
       autoplay on this path — user still has to press play. */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            hydrate(false);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      io.observe(el);
    } else {
      hydrate(false);
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wl-enquiry"] && !Shopify.designMode) return;
  try {
    /* The contact form posts as a full page load and returns at the top of the
     page, so the confirmation would be off screen. Bring it into view and move
     focus to it, which also announces it to screen readers. */
  (function () {
    var msg = document.querySelector('[data-wl-enquiry-success]');
    if (!msg) return;
    msg.scrollIntoView({ block: 'center', behavior: 'auto' });
    msg.focus({ preventScroll: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wl-media-accordion"] && !Shopify.designMode) return;
  try {
    /* Single-open behaviour. Data-attribute scoped so twc.js's generic
     .accordion handler cannot also wire these. <details> still works
     natively if this never runs. */
  document.querySelectorAll('[data-wl-accordion]').forEach(function (acc) {
    if (acc.dataset.closeOthers !== 'true') return;
    var settling = false;
    acc.addEventListener('toggle', function (e) {
      var d = e.target;
      if (settling || !(d instanceof HTMLDetailsElement) || !d.open) return;
      if (!d.classList.contains('wl-macc__item')) return;
      settling = true;
      acc.querySelectorAll('.wl-macc__item').forEach(function (other) {
        if (other !== d) other.open = false;
      });
      settling = false;
    }, true);
  });
  } catch(e) { console.error(e); }
})();

})();
